import _ from 'lodash';

export default class BonDeLivraison {
  constructor(data) {
    this.id = _.get(data, 'id', undefined);
    this.ref = _.get(data, 'ref', undefined);
    this.shopId = _.get(data, 'shopId', undefined);
    this.supplierId = _.get(data, 'supplierId', undefined);
    this.status = _.get(data, 'status', undefined);
    this.createdAt = _.get(data, 'createdAt', undefined);
    this.deliveryExpectedAt = _.get(data, 'deliveryExpectedAt', undefined);
  }

  static get statusTypes() {
    return {
      delivered: 'DELIVERED',
      pending: 'PENDING',
    };
  }

  get statusTypes() {
    return this.constructor.statusTypes;
  }
}
